import { TableHeaderType } from "../types/TableHeaderType";

export const VmTemplateHeader: TableHeaderType[] = [
  {
    label: "Name",
    key: "name",
    id: "name",
    sortable: true,
  },
  {
    label: "CloudProvisioner",
    key: "cloudProvisionerTemplateFile",
    id: "cloudProvisionerTemplateFile",
    sortable: true,
  },
  {
    label: "CloudEnvironment",
    key: "environment",
    id: "environment",
    sortable: true,
  },
  {
    id: "creationDate",
    label: "CreationDate",
    sortable: true,
    key: "creationDate",
  },
  
];